import { useState, useEffect, Fragment } from "react";
import Config from "../Config";


 


function PackToZip(props)
{
 
 

    const [status,setStatus] = useState(0);  //0 - czeka na start, 1-tworzy, 2 - utworzono - wszystkie gotowe,  
    const [archFileName, setArchFileName] = useState("");
    const [tab,setTab] = useState(props.tab);
    const [b64, setB64] = useState("");
    const [size, setSize] = useState(-1);
    const [actualPack, setActualPack] = useState("");
   

    const createArch = (e) => {

        setStatus(1);

        e.target.innerHTML = "...";      

        props.mainView.showProgress();

        var req =  {};


        fetch( Config.master + '/rest_v1,zip_create', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                   

                    props.mainView.hideProgress();       
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         if(res.status == "OK")
                         {
                            var fileName = res.result;
                            setArchFileName(fileName);
                            addNextFile(fileName);
                         }else 
                         {
                            props.mainView.showDialog( "Error", "Nie można utworzyć archiwum" , "error" , null);  
                         }
             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "error" , null);
                   props.mainView.hideProgress();
         });
                   

         return false;

    }




    const addNextFile = (fileName) => {


        var inx = -1;

        var newTmp = new Array();

        for(var k=0; k < tab.length; k++ )
        {
            if(tab[k].status == undefined && inx == -1)
            {
                tab[k].status = 1;
                inx = k;            
            }
            newTmp.push( tab[k] );
        }

        if(inx < 0)
        {
            setStatus(2);
            setActualPack("");
            goDownload(fileName);           
            return;
        }

        setTab(newTmp);
      


        var titleFile = tab[inx].title;
        var idToAdd = tab[inx].typ_id;
        var typToAdd = tab[inx].typ;

        setActualPack(titleFile);

       props.mainView.showProgress();

        var req =  {
            zip: fileName,
            typ_id: idToAdd,
            typ: typToAdd,
        };


        fetch( Config.master + '/rest_v1,zip_add_file', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                   

                   props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                         if(res.status == "OK")
                         {
                            sessionStorage.setItem("click-action-count", 0); //by nie wywaliło błędu ze za dużo wywołań


                            var newTmpX = new Array();

                            for(var k=0; k < tab.length; k++ )
                            {
                                if(tab[k].status == 1 && tab[k].typ_id == idToAdd )
                                {
                                    tab[k].status = 2;                                
                                }                    
                                newTmpX.push( tab[k] );
                            }                                               
                    
                            setTab(newTmpX);
                            addNextFile(fileName);
                            setSize(res.size);

                         }else 
                         {
                            props.mainView.showDialog( "Error", "Nie można utworzyć archiwum" , "ok" , null);  
                         }
             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;

    }



    const goDownload = (filedName) => {

       
        setArchFileName(filedName);
       

        props.mainView.showProgress();

        var req =  {
            zip: filedName,
        };


        fetch( Config.master + '/rest_v1,zip_get', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                   

                    props.mainView.hideProgress();       
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                         if(res.status == "OK")
                         {                            
                            setB64(res.result);
                         }else 
                         {
                            props.mainView.showDialog( "Error", "Nie można pobrać archiwum" , "ok" , null);  
                         }
             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;

    }



    var all = tab.length;
    var ready = 0;

    for(var k=0; k < tab.length; k++ )
        {
            if(tab[k].status != undefined && tab[k].status == 2)
            {
                ready = ready + 1;
            }          
        }

    var proc = 0;
    if(all != 0) proc = ready * 100 / all;   

   
    

  
    return   <div className="dlg_window dlg_type_x shadowx">

    <div className="dlg_title">
        Archiwum ZIP (wybrano plików: {tab.length})
    </div>


    <div className="dlg_content_x">


                    <div className="form_tab">

                     
 
    

                        <div className="form_split"></div>
                            
                    
                            <div className="zip_scroll">
                                <table className="table">
                                    <tbody>
                                    {
                                        tab.map( (row,ix) => {

                                                 

                                                return <tr key={ix}>                                                    

                                                    <td>
                                                        {row.title}
                                                    </td>

                                                    <td className="gocenter">
                                                        {
                                                            row.status == undefined &&
                                                            <span>w kolejce</span>
                                                        }

                                                        {
                                                            row.status != undefined && row.status == 1 &&
                                                            <span>pakuję...</span>
                                                        }

                                                        {
                                                            row.status != undefined && row.status == 2 &&
                                                            <span>gotowe</span>
                                                        }
                                                         
                                                    </td>
                                                </tr>
                                        } )
                                    }
                                    </tbody>
                                </table>                                    
                            </div>
  
 
                         {
                            all > 0 && ready != all &&
                            <div className="progressBarZip"> 
                                <div className="progressLineZip" style={{ "width": proc+"%" }} > </div>  
                            </div>  
                         }                                        

                          {
                            ready > 0 && ready != all &&
                            <Fragment>
                                    <div>
                                        Przetwarzam: {actualPack}
                                    </div>
                                    <div>
                                        Spakowano plików: {ready} z {all}, aktualny rozmiar archiwum: {size}b
                                    </div>
                            </Fragment>                           
                          }           


                        <div className="form_split"></div>
                        <br/>
                        <div className="form_control">    
                            {
                                status == 0 &&
                                <div className="btn" onClick={createArch}>start</div>
                            }   

                           

                            {
                                status == 2 && b64.length > 10 &&                            
                                <b>
                                <a href={"data:application/zip;base64," + b64} className="link_color" >pobierz {archFileName}</a>
                                </b>
                            }                                    
                            
                            {
                                status != 1 &&
                                <Fragment>
                                    &nbsp; &nbsp;
                                    <div className="btn" onClick={props.onClose}>anuluj</div>
                                </Fragment>
                            }
                           
                            
                        </div>

                    
                        </div>

    </div>


</div>
}


export default PackToZip;